// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"630":"code_activation-CodeActivationModal","777":"code_activation-PhoneVerification"}[chunkId] + "." + {"630":"453d8f9fed812aed977b","777":"98105545e4d6b0aa044d"}[chunkId] + ".js";
};